var _styled;

// https://govuk-static.herokuapp.com/component-guide/related_items
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import * as COLOUR from 'govuk-colours';
import { FONT_SIZE, LINE_HEIGHT, MEDIA_QUERIES, SPACING } from '@govuk-react/constants';
import { withWhiteSpace } from '@govuk-react/hoc';
var StyledRelatedItems = styled('div')((_styled = {
  borderTop: "10px solid " + COLOUR.BLUE,
  paddingTop: SPACING.SCALE_1,
  width: '100%'
}, _styled[MEDIA_QUERIES.LARGESCREEN] = {
  fontSize: FONT_SIZE.SIZE_16,
  lineHeight: LINE_HEIGHT.SIZE_16
}, _styled['> h3'] = {
  marginBottom: SPACING.SCALE_2
}, _styled['> ul'] = {
  marginBottom: SPACING.SCALE_4,
  '> li': {
    marginBottom: "calc(" + SPACING.SCALE_2 + " + 2px)"
  }
}, _styled));

var RelatedItems = function RelatedItems(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement(StyledRelatedItems, {
    className: className
  }, children);
};

RelatedItems.defaultProps = {
  className: undefined
};
RelatedItems.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
} : {};
export default withWhiteSpace({
  marginBottom: 0
})(RelatedItems);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@govuk-react/related-items/es/index.js
// module id = 95
// module chunks = 0